const initialState = {
  // Getting Hs Code List
  isGettingHsCodeList: false,
  hsCodeList: [],

  // is Adding HS Code
  isAddingHsCodeList: false,

  // is Updating HS Code
  isUpdatingHsCodeList: false,

  // is Deleting HS Code
  isDeletingHsCodeList: false,
};

const HsCodeListReducer = (state = initialState, action) => {
  switch (action.type) {
    // Getting Client List
    case "HS_CODE_LIST_REQUEST":
      return {
        ...state,
        isGettingHsCodeList: true,
      };
    case "HS_CODE_LIST_SUCCESS":
      return {
        ...state,
        hsCodeList: action.payload?.data,
        page: action.payload?.page,
        totalResults: action.payload?.totalResults,
        isGettingHsCodeList: false,
      };
    case "HS_CODE_LIST_ERROR":
      return {
        ...state,
        isGettingHsCodeList: false,
      };
    // Editing Client List
    case "ADD_HS_CODE_REQUEST":
      return {
        ...state,
        isAddingHsCodeList: true,
      };
    case "ADD_HS_CODE_SUCCESS":
      return {
        ...state,
        isAddingHsCodeList: false,
      };
    case "ADD_HS_CODE_ERROR":
      return {
        ...state,
        isAddingHsCodeList: false,
      };
    // Updateing HS Client List
    case "UPDATE_HS_CODE_LIST_REQUEST":
      return {
        ...state,
        isUpdatingHsCodeList: true,
      };
    case "UPDATE_HS_CODE_LIST_SUCCESS":
      return {
        ...state,
        isUpdatingHsCodeList: false,
      };
    case "UPDATE_HS_CODE_LIST_ERROR":
      return {
        ...state,
        isUpdatingHsCodeList: false,
      };
    // Deleting HS Client List
    case "DELETE_HS_CODE_LIST_REQUEST":
      return {
        ...state,
        isDeletingHsCodeList: true,
      };
    case "DELETE_HS_CODE_LIST_SUCCESS":
      return {
        ...state,
        isDeletingHsCodeList: false,
      };
    case "DELETE_HS_CODE_LIST_ERROR":
      return {
        ...state,
        isDeletingHsCodeList: false,
      };
    default:
      return state;
  }
};

export default HsCodeListReducer;
